/**
 * LMTM 一覧の「絞り込み」＋「+ VIEW MORE」（すべて DOM 内で完結する版）
 *
 * 商品一覧・お知らせ一覧の VIEW MORE は次ページを fetch する（lmtm-collection.js）。
 * こちらは全件がすでに DOM にある一覧向け。customer.orders のように
 * paginate が next を生成できない場合に使う。
 *
 * マークアップ:
 *   <div data-lmtm-showmore data-lmtm-showmore-step="20" data-lmtm-showmore-label="VIEW MORE">
 *     <div data-lmtm-filter>                          ← 任意
 *       <button data-lmtm-filter-value="">すべて</button>
 *       <button data-lmtm-filter-value="medaka">めだか</button>
 *     </div>
 *     <div data-lmtm-showmore-item data-lmtm-filter-key="medaka kohaku">…</div> × N
 *   </div>
 *
 * ボタンは JS が生成する。JS が動かなければ全件がそのまま見えるだけなので、
 * 「押せないボタンが残る」「中身が見えなくなる」ことは起きない。
 * 絞り込みも同じ理由で、ボタンは Liquid 側で hidden にしておき JS が開く。
 */
(function () {
  'use strict';

  function init(root) {
    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-lmtm-showmore-item]')
    );
    if (items.length === 0) return;

    var step = parseInt(root.getAttribute('data-lmtm-showmore-step'), 10);
    if (isNaN(step) || step < 1) step = 20;

    var filterBar = root.querySelector('[data-lmtm-filter]');
    var active = '';
    var shown = step;

    // 「+ VIEW MORE」
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lmtm-collection__viewmore lmtm-showmore__button';
    button.textContent = '+ ' + (root.getAttribute('data-lmtm-showmore-label') || 'VIEW MORE');

    var wrap = document.createElement('div');
    wrap.className = 'lmtm-showmore__more';
    wrap.appendChild(button);
    root.appendChild(wrap);

    function matches(el) {
      if (active === '') return true;
      var keys = (el.getAttribute('data-lmtm-filter-key') || '').split(/\s+/);
      return keys.indexOf(active) !== -1;
    }

    function sync() {
      var seen = 0;
      items.forEach(function (el) {
        if (!matches(el)) {
          el.hidden = true;
          return;
        }
        seen += 1;
        el.hidden = seen > shown;
      });

      // 絞り込んだ結果が step 以下ならボタンは要らない
      wrap.hidden = seen <= shown;

      var empty = root.querySelector('[data-lmtm-showmore-empty]');
      if (empty) empty.hidden = seen !== 0;
    }

    button.addEventListener('click', function () {
      var next = items.filter(matches)[shown];
      shown += step;
      sync();
      // 追加分の先頭にフォーカスを移し、キーボード操作でも続きが読めるようにする
      if (next) {
        next.setAttribute('tabindex', '-1');
        next.focus({ preventScroll: true });
      }
    });

    if (filterBar) {
      filterBar.hidden = false;
      filterBar.addEventListener('click', function (event) {
        var target = event.target.closest('[data-lmtm-filter-value]');
        if (!target) return;

        active = target.getAttribute('data-lmtm-filter-value') || '';
        shown = step; // 絞り込みを変えたら表示件数はリセットする

        filterBar.querySelectorAll('[data-lmtm-filter-value]').forEach(function (el) {
          var on = el === target;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        sync();
      });
    }

    sync();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lmtm-showmore]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();
